import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { NavParams, ToastController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { IDatePlace } from "src/app/models/location.model";
import { OrderModel } from "src/app/models/order.model";
import { ProductModel } from "src/app/models/product.model";
import { ProfileModel } from "src/app/models/profile.model";
import { TourneeModel } from "src/app/models/tournee.model";
import { UserModel } from "src/app/models/user.model";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { DataService } from "src/app/services/data/data.service";
import { HomeService } from "src/app/services/home-service/home.service";
import { MathService } from "src/app/services/math/math.service";
//declare const mangoPay: any;

@Component({
  selector: "producer-order",
  templateUrl: "./producer-order.component.html",
  styleUrls: ["./producer-order.component.scss"]
})
export class ProducerOrderComponent implements OnInit {
  @Input()
  title: string;

  @Input()
  mode: string; // edit, view, order, catalog, sale

  @Input()
  order: OrderModel;

  @Input("producer")
  set producer(value:ProfileModel){
    if(value && value.key){
      this._producer = value;    
    }
  }
  _producer: ProfileModel;

  @Input()
  sale: TourneeModel;

  @Input()
  products:ProductModel[];

  @Input()
  dates: IDatePlace[];

  @Input()
  user: UserModel;

  @Input()
  sortBy: string;

  @Input()
  owner: ProfileModel;

  @Input()
  public onCancel = () => {};

  @Input()
  public onOrder = () => {};

  @Input()
  public onOrderCreated = (order:OrderModel) => {}
 

  @Input()
  state:string;

  @Input()
  consumers:ProfileModel[] = [];

  @Output() orderDone = new EventEmitter<OrderModel>();

  formComment: UntypedFormGroup;
  formContract: UntypedFormGroup;
  formFullProfile: UntypedFormGroup;
  formAddress: UntypedFormGroup;
  formRegister: UntypedFormGroup;
  formPaymentContactDetails: UntypedFormGroup;
  // work around due to display issues with Safari. The autocomplete function of safari moves the slide until email and password fields are visible
  onSafari = false;
  loading = false;
  deliveryTypesWithTimingAndPlace = ["market", "collectpoint", "ownshop", "pickupstore"];
  deliveryTypesWithName = ["pickupstore"];
  canOrder = true;
  canPay = false;
  shouldPay = false;
  hasSkippedPayment = false;
  canPayEntirely = false;
  cantOrderMessage = "";
  needsAddress = false;
  psp= '';
  processingMessage="";
  @Input()
  paymentKey:string;

  constructor(
    private dataService: DataService,
    private mathService: MathService,
    public formBuilder: UntypedFormBuilder,
    public auth: AuthenticationService,
    private translateService: TranslateService,
    private navParams: NavParams,
    private homeService: HomeService,
    private toastCtrl: ToastController,
    // private iab: InAppBrowser
  ) {
    this.order = this.navParams.data.order;
    this.state = this.navParams.data.state;
    this.paymentKey = this.navParams.data.paymentKey;
    console.log('basket order: order, state',this.order, this.state);
    
    this.needsAddress =
      (this.order.market && this.order.market.details && this.order.market.details.deliveryType == "tournee") ||
      (this.order.tournee && this.order.tournee.details && this.order.tournee.details.deliveryType == "tournee");
    this.formComment = this.formBuilder.group({
      comment: [""],
    });

    this.formFullProfile = this.formBuilder.group({
      key: [null, Validators.compose([Validators.required])],
      details: this.formBuilder.group({
        fullDetails: this.formBuilder.group({
          lastname: [null, Validators.compose([Validators.required])],
          firstname: [null, Validators.compose([Validators.required])],
          phone: [null, Validators.compose([Validators.required])]          
        })
      })
    });
    this.formFullProfile.patchValue(this.order.consumer);
    this.formAddress = this.formBuilder.group({
      geocoding: [null, Validators.compose([Validators.required])]
    });
  }

  ngOnInit() {}

  cancel() {
    this.onCancel();
  }

  async next(state: string) {
    // BASKET
    if (state == "catalog") {
      this.goToState('basket');
    } 
    else if (state == "basket") {
      this.goToState('client');
    } 
    // PROFILE
    else if (state == "profile"  && this.formFullProfile.controls.key.valid
     && ((this.formFullProfile.value.key === 'new' && this.formFullProfile.controls.details.valid) || this.formFullProfile.value.key !== 'new') ) { 
      console.log('consumer',this.order.consumer); 
      if (this.needsAddress) {
        this.goToState('address');
      } else {
        this.goToState('comment');
      }
    } 
    // ADDRESS
    else if (state == "address") {
      if(this.formAddress.valid){
        console.log(this.formAddress.value);
        if(!this.order.consumer.details || !this.order.consumer.details.geocoding || this.formAddress.value.geocoding.locationID != this.order.consumer.details.geocoding.locationID){
          this.order.consumer.details.geocoding = this.formAddress.value.geocoding;
          console.log('update consumer geocoding',this.order.consumer.details.geocoding);
          await this.dataService.updateProducerConsumerGeocoding(this.order.consumer, this._producer.key);
        }
        else{
          this.order.consumer.details.geocoding = this.formAddress.value.geocoding;
        }
        this.order.route.geocoding = this.formAddress.value.geocoding;
        this.goToState('comment');
      }
      else{
        this.stayOnTheSlide(this.translateService.instant("alerts.invalidFullAddress"));
      }

    } 
    // COMMENT
    else if (state == "comment") {
      this.order.paymentStatus = "unpaid";
        // this.confirmOrder();
        this.saveOrder();
    }
  }

  onQuantityChanged(product: ProductModel): void {
    console.log(product);
    if (this.order.products.references && this.order.products.references[product.key] && product.basket.quantity == 0) {
      delete this.order.products.references[product.key];
      delete this.order.products.references['deliveryCost'];
      delete this.order.products.references['commission'];
      delete this.order.products.references['deposit'];
      
    } else {
      if (!this.order.products.references) {
        this.order.products = {
          references: {
            [product.key]: product
          }
        };
      } else {
        this.order.products.references[product.key] = product;
      }
    }
    this.order = this.mathService.calculateMultiOrder(this.order);
    console.log(this.order);
  }

  async prev(state: string): Promise<void> {
    if (state == "basket"){
      this.goToState('catalog');
    }
    else if (state == "client"){
      this.goToState('basket');
    }
    else if (state == "address"){
      this.goToState('client');
    }
    else if (state == "comment") {
      if (this.needsAddress) {
        this.goToState('address');
      } else {
        this.goToState('client');
      }
    }
  }

  goToState(state:string){
    this.state = state;
  }

  stayOnTheSlide(onmessage: string): void {
    this.presentToast(onmessage);
    this.loading = false;
  }

  public goHome(): void {
    this.homeService.navigateToHome();
  }

  async saveOrder() {
    this.formComment.disable();
    this.formFullProfile.disable();
    this.formAddress.disable();
    this.order.status = "created";
    if(this.formFullProfile.value.key === 'new'){
      this.order.consumer= {
        details:{
          fullDetails:{
            firstname: this.formFullProfile.value.details.fullDetails.firstname,
            lastname: this.formFullProfile.value.details.fullDetails.lastname,
            phone: this.formFullProfile.value.details.fullDetails.phone,
          },
          shortDetails:{
            name: this.formFullProfile.value.details.fullDetails.lastname + " " + this.formFullProfile.value.details.fullDetails.firstname.slice(0, 1) + "."
          }
        },
        status: 'unregistered'
      }
      const createConsumerResult = await this.dataService.createProducerConsumer(this.order.consumer, this._producer.key);
      this.order.consumer.key = createConsumerResult.key;
      console.log('new consumer key',createConsumerResult.key);
      this.consumers.splice(0,0,this.order.consumer);
    }
    else if(this.formFullProfile.value.key === 'anonymous'){
      this.order.consumer = {key:'anonymous',status:'unregistered'};
    }
    else{
      this.order.consumer = this.consumers.find(item => item.key === this.formFullProfile.value.key);
    }
    this.order = this.mathService.calculateMultiOrder(this.order);
    if (this.order.details.format == "group" && this.order.tournees) {
      for (const tourneeKey in this.order.tournees) {
        this.order.tournees[tourneeKey].status = "created"; // to be checked if correct
        this.order.tournees[tourneeKey].orderStatus = "created";
      }
    }
    this.order.details.dateOrdered = Date();
    this.loading = true;
    try {
      const result = await this.dataService.createOrderIntoProducer(this.order, this._producer.key, this.sale.key);
      this.order.key = result.key;
      this.onOrderCreated(this.order);
    } catch (error) {
      console.log(error);
      this.formFullProfile.enable();
      this.formAddress.enable();
      this.formComment.enable();
      this.loading = false;
      this.presentToast(this.translateService.instant("errors.ConnectionIssueTryAgainLater") + ": " + error);
    }    
  }

  closeToast(): void {
    if (typeof this.toastCtrl != "undefined") {
      this.toastCtrl.dismiss();
    }
  }

  async presentToast(message: string): Promise<void> {
    const toast = await this.toastCtrl.create({
      message: message,
      duration: 15000,
      buttons: [
        {
          side: "end",
          icon: "close-circle-outline",
          role: "cancel",
          handler: () => {
            console.log("dismiss toast");
            //toast.dismiss();
          }
        }
      ],
      position: "middle"
    });
    toast.present();
  }

  onDateChanged(event){
    if(event.selected){
      this.order.details.datePlace = event;
    }
    else{
      this.order.details.datePlace = null;
    }
  }
  onConsumerChange(event){
    if(event.detail.value !== 'new' && event.target.id === 'client-radio'){
      this.next('profile');
    }
  }
}